




import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

const name = 'CaskSubscriptionListIframe';

export default pageFactory(name, pageStoreBuilder({
	name,
	crumbLabel: 'ADM_CaskPredplatne',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
}));
